export default {
  PRIVATE_KEY: `${window.SERVER_URL}private-key.pem`,
  CERT: `${window.SERVER_URL}digital-certificate.txt`,
};
